<app-component-header></app-component-header>

<div class="container mt-5 content">
    <div class="pt-1">
        <div class="row mt-5">
            <div class="col-12">
                <h2 class="mb-0 text-sacom">Đặt hẹn giao dịch</h2>
            </div>
        </div>
        <div *ngIf="isInput">
            <form nz-form [formGroup]="bookingForm" [hidden]="">
                <div class="row">
                    <div class="mt-3 col-xs-12 col-sm-4">
                        <nz-form-label nzRequired nzFor="txtIdentity">CMND/Passport/CCCD</nz-form-label>
                        <input nz-input type="text" #txtIdentity numberOnly="true" placeHolder="Vui lòng nhập CMND/Passport/CCCD" formControlName="customerIdentity" />
                    </div>
                    <div class="mt-3 col-xs-12 col-sm-4">
                        <nz-form-label nzRequired nzFor="txtCustomerName">Họ tên khách hàng</nz-form-label>
                        <input nz-input type="text" #txtCustomerName placeHolder="Vui lòng nhập họ và tên" formControlName="customerName" />
                    </div>
                    <div class="mt-3 col-xs-12 col-sm-4">
                        <nz-form-label nzRequired nzFor="txtPhone">Số điện thoại</nz-form-label>
                        <input nz-input type="text" #txtPhone numberOnly="true" placeHolder="Vui lòng nhập Số điện thoại" formControlName="phone" />
                    </div>
                </div>
                <div class="row">
                    <div class="mt-3 col-xs-12 col-sm-4">
                        <nz-form-label nzRequired nzFor="txtEmail">Địa chỉ Email</nz-form-label>
                        <input nz-input type="text" #txtEmail placeHolder="Vui lòng nhập Địa chỉ Email" formControlName="email" />
                    </div>
                    <div class="mt-3 col-xs-12 col-sm-4">
                        <nz-form-label nzRequired nzFor="txtProvince">Tỉnh/ Thành phố</nz-form-label>
                        <nz-select nzShowSearch class="w-100" nzPlaceHolder="Chọn Tỉnh/Thành phố" [nzDropdownMatchSelectWidth]="false" #txtProvince (ngModelChange)="changeProvince()" formControlName="province" [nzLoading]="nzLoadingProvince">
                            <nz-option nzLabel="{{item.name}}" *ngFor="let item of provinces" [nzValue]="item.id">
                            </nz-option>
                        </nz-select>
                    </div>
                    <div class="mt-3 col-xs-12 col-sm-4">
                        <nz-form-label nzRequired nzFor="txtDistrict">Quận/ Huyện</nz-form-label>
                        <nz-select class="w-100" nzShowSearch nzPlaceHolder="Chọn Quận/Huyện" #txtDistrict (ngModelChange)="changeDistrict()" formControlName="district" [nzLoading]="nzLoadingDistrict">
                            <nz-option nzLabel="{{item.name}}" *ngFor="let item of districts" [nzValue]="item.id">
                            </nz-option>
                        </nz-select>
                    </div>
                </div>
                <div class="row">
                    <div class="mt-3 col-xs-12 col-sm-4">
                        <nz-form-label nzRequired nzFor="txtBranch">Đơn vị giao dịch</nz-form-label>
                        <nz-form-control>
                            <nz-select class="w-100" nzShowSearch nzPlaceHolder="Chọn đơn vị giao dịch" #txtBranch (ngModelChange)="changeBranch()" formControlName="branch" [nzLoading]="nzLoadingBranch">
                                <nz-option nzLabel="{{item.name}}" *ngFor="let item of branches" [nzValue]="item.code">
                                </nz-option>
                            </nz-select>
                        </nz-form-control>
                    </div>
                    <div class="mt-3 col-xs-12 col-sm-4">
                        <nz-form-label nzRequired nzFor="txtDate">Ngày</nz-form-label>
                        <div class="input-group">
                            <nz-date-picker class="w-100" nzPlaceHolder="Chọn ngày" nzFormat="dd/MM/yyyy" [nzDisabledDate]="disabledDates" (nzOnOpenChange)="changeBookingDate($event)" formControlName="bookingDate" #txtDate>
                            </nz-date-picker>
                        </div>
                    </div>
                    <div class="mt-3 col-xs-12 col-sm-4">
                        <nz-form-label nzRequired nzFor="txtTime">Thời gian</nz-form-label>
                        <nz-select class="w-100" nzShowSearch nzPlaceHolder="Chọn khung thời gian" #txtTime (ngModelChange)="changeTime()" formControlName="bookingTime"  [nzLoading]="nzLoadingBookingTime">
                            <nz-option nzLabel="{{item.name}}" *ngFor="let item of bookingTimes" [nzValue]="item.id" [nzDisabled]="checkTime(item.startTime)">
                            </nz-option>
                        </nz-select>
                    </div>
                </div>
                <div class="row">
                    <span class="branch-address">
                        {{branchAddress}}
                    </span>
                </div>
                <div class="row">
                    <div class="mt-3 col-xs-12 col-sm-6">
                        <nz-form-label nzRequired nzFor="txtCategory">Nhóm</nz-form-label>
                        <nz-select class="w-100" #txtCategory nzPlaceHolder="Chọn Nhóm dịch vụ" (ngModelChange)="changeProductGroups()" formControlName="productGroup" [nzLoading]="nzLoadingProductGroup">
                            <nz-option nzLabel="{{item.name}}" *ngFor="let item of productGroups" [nzValue]="item.id">
                            </nz-option>
                        </nz-select>
                    </div>
                    <div class="mt-3 col-xs-12 col-sm-6">
                        <nz-form-label nzRequired nzFor="txtProduct">Sản phẩm</nz-form-label>
                        <nz-select class="w-100" nzPlaceHolder="Chọn sản phẩm" nzShowSearch #txtProduct formControlName="product" (ngModelChange)="changeProduct()" [nzLoading]="nzLoadingProduct">
                            <nz-option nzLabel="{{item.name}}" *ngFor="let item of products" [nzValue]="item.id">
                            </nz-option>
                        </nz-select>
                    </div>
                </div>
                <div class="row">
                    <div class="mt-3 col-12">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" formControlName="acceptTermsConditions" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Tôi đồng ý cung cấp thông tin và cho phép SACOMBANK sử dụng thông tin theo các quy định
                                tại
                                <a href="https://www.sacombank.com.vn/Documents/2019/0607/Chinh%20sach%20bao%20mat%20thong%20tin.pdf"
                                    target="_blank">Chính sách bảo mật thông tin</a>
                            </label>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row my-3">
                <div class="text-center div-center">
                    <!-- <button nz-button nzType="primary" class="w-sm-100" (click)="submitForm()">Đặt hẹn</button> -->
                    <button nz-button nzType="primary" nzSize="large" nzShape="round" class="btn-sacom-o" (click)="submitForm()" *ngIf="!isLoading">Đặt hẹn</button>
                    <button nz-button nzType="primary" nzSize="large" nzShape="round" class="btn-sacom-o btnDisabled" *ngIf="isLoading">Đang xử lý</button>
                </div>
            </div>
            <div *ngIf="isLoading" class="loading-container">
                <div class="loading-spin">
                    <ng-template #indicatorTemplate><i nz-icon nzType="loading"></i></ng-template>
                    <nz-spin nzSimple [nzSize]="'large'" [nzIndicator]="indicatorTemplate"></nz-spin>
                </div>
            </div>
        </div>
        <div *ngIf="!isInput">
            <h4  style="text-align: center">ĐẶT HẸN THÀNH CÔNG</h4>

            <div>Quý khách <span class="text-piority"> {{outputCustomerName}}
                </span> đã đặt hẹn thành công sản phẩm <span style='color:red'> {{outputProduct}}
                </span> tại CN/PGD <span class="text-piority"> {{outputBranch}}
                </span> vào lúc <span class="text-piority"> {{outputBookingTimeName }}</span> ngày <span style='color:red'>
                    {{outputDateBooking | date: 'dd/MM/yyyy'}}</span>.</div>
            <div class="mt-3">Vui lòng lưu giữ Mã đặt hẹn/Mã nhận diện (QR Code) và đến đúng thời điểm đã đặt hẹn để được ưu tiên phục vụ.</div>
            <div>
                <div class="div-center" style="text-align: center">
                    <img [src]="imgQrCode" height="200px" width="200px" *ngIf="imgQrCode" />
                    <div class="text-center mt-3"><span class="text-piority">{{outputBookingCode}}</span></div>
                </div>
            </div>
            <div><b>SACOMBANK</b> trân trọng cảm ơn quý khách.</div>
            <div class="row">
                <div class="text-center div-center">
                    <button nz-button nzType="primary" class="w-sm-100" (click)="backToBooking()">Về trang đặt hẹn</button>
                    <button nz-button nzType="primary" class="w-sm-100" (click)="backToBooking()">Điền trước biểu mẫu</button>
                </div>
            </div>
        </div>
    </div>
</div>

<app-component-footer></app-component-footer>